<div class="parallax fullwidth">
  <div class="parallax-content">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="main-search-container">
            <h2>“Your Property” “Our Priority”</h2>
            <form (ngSubmit)="SearchProperty()" #searchForm="ngForm" class="main-search-form">
              <div class="search-type">
                <label [class.active]="Purpose == 0">
                  <input (change)="onRadioItemChange($event.target.value)" name="tab" type="radio" value="0">
                  Any Status
                </label>
                <label [class.active]="Purpose == 1">
                  <input (change)="onRadioItemChange($event.target.value)" name="tab" type="radio" value="1">
                  For Sale
                </label>
                <label [class.active]="Purpose == 2">
                  <input (change)="onRadioItemChange($event.target.value)" name="tab" type="radio" value="2">
                  For Rent
                </label>
                <div class="search-type-arrow" style="left: 41.075px;"></div>
              </div>
              <div class="main-search-box">
                <div class="row with-forms">
                  <div class="col-md-3 margin-top-10">
                    <ng-select #CityDropdown [items]="PropertyCities" bindLabel="Text" bindValue="Id"
                               placeholder="Search city" [(ngModel)]="City" name="city" (change)="cityLocations()">
                      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value" *ngFor="let item of items | slice:0:1">
                          <span class="ng-value-label">
                            <i class="im im-icon-Location"></i>
                            {{item.Text}}
                          </span>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-md-4 margin-top-10">
                    <ng-select [items]="PropertyLocations" [multiple]="true" bindLabel="Text" name="locations" bindValue="Id"
                               [(ngModel)]="Locations" placeholder="Search city locations">
                      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value" *ngFor="let item of items | slice:0:1">
                          <span class="ng-value-label">
                            <i class="sl sl-icon-location"></i>
                            {{item.Text}}
                          </span>
                        </div>
                        <div class="ng-value" *ngIf="items.length > 1">
                          <span class="ng-value-label">{{items.length - 1}} more...</span>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-md-3 margin-top-10">
                    <input type="text"  [(ngModel)]="Keywords"  class="form-control input-text" name="Keywords" />
                  </div>
                  <div class="col-md-2 margin-top-10">
                    <div class=" larger-input">
                      <button class="button" type="Submit">Search</button>
                    </div>
                  </div>
                </div>
                <a href="javascript:void(0);" class="more-search-options-trigger" data-open-title="More Options"
                   data-close-title="Less Options"></a>
                <div class="more-search-options">
                  <div class="more-search-options-container">
                    <div class="row with-forms">
                      <div class="col-md-3 margin-top-10">
                        <ng-select [items]="PropertyTypes" bindLabel="Text" bindValue="Id" [(ngModel)]="PropertyType"
                                   placeholder="Select Property Type" name="propType"  (change)="PropertyTypeChange()">
                          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:1">
                              <span class="ng-value-label">
                                <i class="sl sl-icon-home"></i>
                                {{item.Text}}
                              </span>
                              <span class="ng-value-icon right" aria-hidden="true">×</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div class="col-md-4 margin-top-10">
                        <ng-select [(ngModel)]="MinPrice" name="MinPrice" placeholder="Select Min Price"
                                   (change)="PriceORAreaOnChange('Price')">
                          <ng-option value="0">0</ng-option>
                          <ng-option value="50,000">50,000</ng-option>
                          <ng-option value="250,000"> 250,000</ng-option>
                          <ng-option value="500,000"> 500,000</ng-option>
                          <ng-option value="1,000,000"> 1,000,000</ng-option>
                          <ng-option value="2,000,000"> 2,000,000</ng-option>
                          <ng-option value="3,000,000"> 3,000,000</ng-option>
                          <ng-option value="4,000,000"> 4,000,000</ng-option>
                          <ng-option value="5,000,000"> 5,000,000</ng-option>
                          <ng-option value="7,500,000"> 7,500,000</ng-option>
                          <ng-option value="10,000,000"> 10,000,000</ng-option>
                          <ng-option value="25,000,000"> 25,000,000</ng-option>
                          <ng-option value="50,000,000"> 50,000,000</ng-option>
                          <ng-option value="100,000,000"> 100,000,000</ng-option>
                          <ng-option value="250,000,000"> 250,000,000</ng-option>
                          <ng-option value="500,000,000"> 500,000,000</ng-option>
                          <ng-option value="1000,000,000"> 1000,000,000</ng-option>
                        </ng-select>
                      </div>
                      <div class="col-md-4 margin-top-10">
                        <ng-select [(ngModel)]="MaxPrice" placeholder="Select Max Price" name="MaxPrice"
                                   (change)="PriceORAreaOnChange('Price')">
                          <ng-option value="50,000"> 50,000</ng-option>
                          <ng-option value="250,000"> 250,000</ng-option>
                          <ng-option value="50,0000"> 500,000</ng-option>
                          <ng-option value="1,000,000"> 1,000,000</ng-option>
                          <ng-option value="2,000,000"> 2,000,000</ng-option>
                          <ng-option value="3,000,000"> 3,000,000</ng-option>
                          <ng-option value="4,000,000"> 4,000,000</ng-option>
                          <ng-option value="5,000,000"> 5,000,000</ng-option>
                          <ng-option value="7,500,000"> 7,500,000</ng-option>
                          <ng-option value="10,000,000"> 10,000,000</ng-option>
                          <ng-option value="25,000,000"> 25,000,000</ng-option>
                          <ng-option value="50,000,000"> 50,000,000</ng-option>
                          <ng-option value="100,000,000"> 100,000,000</ng-option>
                          <ng-option value="250,000,000"> 250,000,000</ng-option>
                          <ng-option value="500,000,000"> 500,000,000</ng-option>
                          <ng-option value="1000,000,000"> 1000,000,000</ng-option>
                        </ng-select>
                      </div>
                    </div>
                    <div class="row with-forms">
                      <div class="col-md-3 margin-top-10">
                        <ng-select [items]="AreaUnits" bindLabel="Text" bindValue="Id" [(ngModel)]="AreaUnit"
                                   placeholder="Select Area Unit" name="areaUnit">
                          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:1">
                              <span class="ng-value-label">
                                <i class="sl sl-icon-social-dropbox"></i>
                                {{item.Text}}
                              </span>
                              <span class="ng-value-icon right" aria-hidden="true">×</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div class="col-md-4 margin-top-10">
                        <ng-select [(ngModel)]="MinArea" placeholder="Select Min Area" name="min-area"
                                   (change)="PriceORAreaOnChange('Area')">
                          <ng-option value="0">0</ng-option>
                          <ng-option value="80">80</ng-option>
                          <ng-option value="120">120</ng-option>
                          <ng-option value="150">150</ng-option>
                          <ng-option value="200">200</ng-option>
                          <ng-option value="400">400</ng-option>
                          <ng-option value="1,000">1,000</ng-option>
                          <ng-option value="2,000">2,000</ng-option>
                          <ng-option value="5,000">5,000</ng-option>
                          <ng-option value="10,000">10,000</ng-option>
                          <ng-option value="15,000">15,000</ng-option>
                        </ng-select>
                      </div>
                      <div class="col-md-4 margin-top-10">
                        <ng-select [(ngModel)]="MaxArea" name="max-area" placeholder="Select Max Area"
                                   (change)="PriceORAreaOnChange('Area')">
                          <ng-option value="80">80</ng-option>
                          <ng-option value="120">120</ng-option>
                          <ng-option value="150">150</ng-option>
                          <ng-option value="200">200</ng-option>
                          <ng-option value="400">400</ng-option>
                          <ng-option value="1,000">1,000</ng-option>
                          <ng-option value="2,000">2,000</ng-option>
                          <ng-option value="5,000">5,000</ng-option>
                          <ng-option value="10,000">10,000</ng-option>
                          <ng-option value="15,000">15,000</ng-option>
                        </ng-select>
                      </div>
                    </div>
                    <div class="row with-forms">

                      <div class="col-md-3 margin-top-10" *ngIf="IsHomeCategory">
                        <ng-select [items]="BedRooms" bindLabel="Text" bindValue="Id" [(ngModel)]="BedRoom"
                                   placeholder="Select BedRooms" name="bed">
                          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:1">
                              <span class="ng-value-label">
                                {{item.Text}}
                              </span>
                              <span class="ng-value-icon right" aria-hidden="true">×</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div class="col-md-4 margin-top-10" *ngIf="IsHomeCategory">
                        <ng-select [items]="BathRooms" bindLabel="Text" bindValue="Id" [(ngModel)]="BathRoom"
                                   placeholder="Select Bathrooms" name="bath">
                          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:1">
                              <span class="ng-value-label">
                                <i class="sl sl-bath"></i>

                                {{item.Text}}
                              </span>
                              <span class="ng-value-icon right" aria-hidden="true">×</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-property-listing [collection] ="collection"
                      [isProcessed] = "isProcessed"
                      [IsLoading]="IsLoading">Property Listing Page.
</app-property-listing>
